// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';
// $FlowFixMe
import ArrowUp from '../../../assets/images/company/stakeholders/arrow_up.svg';
// $FlowFixMe
import ArrowUpMuted from '../../../assets/images/company/stakeholders/arrow_up_muted.svg';
// $FlowFixMe
import ArrowDown from '../../../assets/images/company/stakeholders/arrow_down.svg';
// $FlowFixMe
import ArrowDownMuted from '../../../assets/images/company/stakeholders/arrow_down_muted.svg';

export default class IndexView extends JQueryView {
  constructor() {
    super('.stockholders.index');

    if ($('.table-wrapper').height() < 400) {
      $('.table-wrapper').height(400);
    }

    // DSC-4114 正式版では資金調達履歴機能を閉じているため、MUFG環境では資本政策画面からイベント編集をしたい場合は、株式名簿のイベント編集機能を使ってもらう
    if (location.search == '?from_capital_policy=true') {
      $.ajax({
        url: '/company/capital_event_rounds/new',
        type: 'GET',
        dataType: 'script',
      });
    }

    $(function() {
      let width = $(window).width();
      const breakpointWidth = 1760;
      const sortLinks = $('.sort_link');

      if (width <= breakpointWidth) {
        $('.submenu')
          .removeClass('dropright')
          .addClass('dropleft');
      } else {
        $('.submenu')
          .removeClass('dropleft')
          .addClass('dropright');
      }
      sortLinks.each(function(i, sortLink) {
        if (
          $(sortLink).hasClass('font-weight-bold') &&
          !$(sortLink).find('.sort-icon').length
        ) {
          if ($(sortLink).hasClass('desc')) {
            $(sortLink).append(
              `<div class="sort-icon"><img src='${ArrowDown}' class="arrow"></div>`,
            );
          } else if ($(sortLink).hasClass('asc')) {
            $(sortLink).append(
              `<div class="sort-icon"><img src='${ArrowUp}' class="arrow"></div>`,
            );
          }
        }
      });
    });

    this.render();
  }

  render() {
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
          cancelLabel: 'Clear',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({
    event: 'change',
    selector: '.search-form #input_search, .search-form #tran_on_search',
  })
  onChangeSearch() {
    $('.search-form').submit();
  }

  @on({ event: 'click', selector: '.cancel-information' })
  onClickCancelInformation() {
    $('.invited-information').addClass('d-none');
  }

  @on({ event: 'click', selector: '.download-modal .download-btn' })
  onClickDownloadBtn(event: any) {
    event.preventDefault();
    $('.download-modal').modal('hide');
    window.open($(event.target).data('url'), '_blank');
  }

  @on({ event: 'mouseenter', selector: 'th' })
  enterSortLink(event: any) {
    const target = $(event.currentTarget);
    const sortLink = target.find('.sort_link');
    const sortIcon = sortLink.find('.sort-icon');

    if (!sortLink.hasClass('font-weight-bold') && !sortIcon.length) {
      this.setDefaultSortIcon(sortLink);
    }
  }

  @on({ event: 'mouseleave', selector: 'th' })
  leaveSortLink(event: any) {
    const target = $(event.currentTarget);
    const sortLink = target.find('.sort_link');
    const sortIcon = sortLink.find('.sort-icon');

    if (!sortLink.hasClass('font-weight-bold')) {
      sortIcon.remove();
    }
  }

  @on({ event: 'click', selector: '.sort_link' })
  clickSelectedSortLink(event: any) {
    if ($(event.target).closest('.sort-icon').length) {
      // .sort_iconをクリックしていた場合は処理をスキップ
      return;
    }

    const sortLink = $(event.target);
    this.selectSortItem(sortLink);
  }

  @on({ event: 'mouseenter', selector: '.sort-icon' })
  enterSortIcon(event: any) {
    const sortIcon = $(event.currentTarget);
    const sortLink = sortIcon.parent('.sort_link');

    if (sortLink.hasClass('font-weight-bold')) {
      sortIcon.addClass('sort-icon-hover');
    }
  }

  @on({ event: 'mouseleave', selector: '.sort-icon' })
  leaveSortIcon(event: any) {
    const sortIcon = $(event.currentTarget);
    const sortLink = sortIcon.parent('.sort_link');

    if (sortLink.hasClass('font-weight-bold')) {
      sortIcon.removeClass('sort-icon-hover');
    }
  }

  @on({ event: 'mouseover', selector: '.dropdown-link' })
  hoverDropdownLink(event: any) {
    if (
      !$(event.target)
        .parent()
        .parent()
        .next()
        .hasClass('show')
    ) {
      $('.dropdown-stockholder').removeClass('show');
    }
  }

  selectSortItem(sortLink: any) {
    const currentSortLink = $('.sort_link' + '.font-weight-bold');

    if (!currentSortLink.is(sortLink)) {
      currentSortLink
        .removeClass('font-weight-bold')
        .find('.sort-icon')
        .remove();
      sortLink
        .addClass('font-weight-bold')
        .find('.sort-icon')
        .remove();
      this.setDefaultSortIcon(sortLink);

      // クリックした項目が既に第2、第3ソートで並び替えられていた場合、URLに付与するパラメータを項目デフォルトの
      // ソート条件（昇順、降順）のものに書き換える(「取得年月日」、「株式数」でソートするときのみ)
      if (sortLink.attr('href').includes('stocks_tran_on+desc')) {
        const url = sortLink
          .attr('href')
          .replace('stocks_tran_on+desc', 'stocks_tran_on+asc');
        sortLink.attr('href', url);
      } else if (sortLink.attr('href').includes('sum_total_quantity+asc')) {
        const url = sortLink
          .attr('href')
          .replace('sum_total_quantity+asc', 'sum_total_quantity+desc');
        sortLink.attr('href', url);
      }
    }
  }

  setDefaultSortIcon(sortLink: any) {
    switch (sortLink.text()) {
      case '名前':
      case '取得年月日':
        if (sortLink.hasClass('font-weight-bold')) {
          sortLink.append(
            `<div class="sort-icon"><img src='${ArrowUp}' class="arrow"></div>`,
          );
        } else {
          sortLink.append(
            `<div class="sort-icon"><img src='${ArrowUpMuted}' class="arrow"></div>`,
          );
        }
        break;
      case '株式数':
      case '電磁的招集':
        if (sortLink.hasClass('font-weight-bold')) {
          sortLink.append(
            `<div class="sort-icon"><img src='${ArrowDown}' class="arrow"></div>`,
          );
        } else {
          sortLink.append(
            `<div class="sort-icon"><img src='${ArrowDownMuted}' class="arrow"></div>`,
          );
        }
        break;
    }
  }
}
